import script from "./DesktopMyGit.vue?vue&type=script&setup=true&lang=js"
export * from "./DesktopMyGit.vue?vue&type=script&setup=true&lang=js"

import "./DesktopMyGit.vue?vue&type=style&index=0&id=3ead68be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ead68be"]])

export default __exports__